import { render, staticRenderFns } from "./PackagePreview.vue?vue&type=template&id=3d00dc4c&scoped=true"
import script from "./PackagePreview.vue?vue&type=script&lang=ts"
export * from "./PackagePreview.vue?vue&type=script&lang=ts"
import style0 from "./PackagePreview.vue?vue&type=style&index=0&id=3d00dc4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d00dc4c",
  null
  
)

export default component.exports